import PageRecord from "models/view-models/page-record";
import React from "react";
import PageListItem from "./page-list-item";
import AddPageButton from "./add-page-button";
import { ViewModes } from "models/enumerations/view-modes/view-modes";
import SortableDragAndDropList from "organisms/sortable-drap-and-drop/sortable-drag-and-drop-list";
import { rectSortingStrategy } from "@dnd-kit/sortable";
import SortableDragAndDropItem, {
    DragButtonStyles,
} from "organisms/sortable-drap-and-drop/sortable-drag-and-drop-item";
import { IconPositions } from "atoms/constants/icon-positions";
import PageListHeader from "./page-list-header";
import usePageViewSettings from "./use-page-view-settings";
import { IconSizes } from "atoms/constants/icon-sizes";

interface PagesProps {
    onCreatePageClick: () => void;
    onPagesReordered: (pages: PageRecord[]) => void;
    pages: PageRecord[];
    showAddPageButton: boolean;
}
const CSS_BASE_CLASS = "c-pages";
const VIEW_MODE_TO_ICON_POSITION: Record<ViewModes, IconPositions> = {
    [ViewModes.Grid]: IconPositions.Top,
    [ViewModes.List]: IconPositions.InnerLeft,
};

const Pages: React.FC<PagesProps> = ({
    onCreatePageClick,
    onPagesReordered,
    pages,
    showAddPageButton,
}) => {
    const { viewMode } = usePageViewSettings();
    const viewSetting = viewMode === ViewModes.List ? "-list" : "-grid";
    const dragButtonStyle =
        viewMode === ViewModes.List
            ? DragButtonStyles.Default
            : DragButtonStyles.Light;
    return (
        <div className={CSS_BASE_CLASS}>
            <PageListHeader />
            <div className={`${CSS_BASE_CLASS}__page-list ${viewSetting}`}>
                {showAddPageButton && (
                    <AddPageButton
                        onCreatePageClick={onCreatePageClick}
                        viewSetting={viewSetting}
                    />
                )}
                <SortableDragAndDropList
                    items={pages}
                    onSortChange={onPagesReordered}
                    strategy={rectSortingStrategy}>
                    {pages.map((page) => (
                        <SortableDragAndDropItem
                            iconPosition={VIEW_MODE_TO_ICON_POSITION[viewMode]}
                            iconOnHoverOnly
                            id={page.id!}
                            key={page.id}
                            dragButtonStyle={dragButtonStyle}
                            size={IconSizes.Large}>
                            <PageListItem page={page} />
                        </SortableDragAndDropItem>
                    ))}
                </SortableDragAndDropList>
            </div>
        </div>
    );
};

export default Pages;
